/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Tab_Resume_DescInputs */

const en_landing_tab_resume_desc = /** @type {(inputs: Landing_Tab_Resume_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Automatically adapt your resume to match any job description. AI detects missing keywords, restructures experience sections, and optimizes formatting — so your CV stands out to ATS screening systems.`)
};

const de_landing_tab_resume_desc = /** @type {(inputs: Landing_Tab_Resume_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Passe deinen Lebenslauf automatisch an jede Stellenbeschreibung an. KI erkennt fehlende Schlüsselwörter, strukturiert Erfahrungsabschnitte um und optimiert die Formatierung — damit dein CV von ATS-Systemen besser erkannt wird.`)
};

const fr_landing_tab_resume_desc = /** @type {(inputs: Landing_Tab_Resume_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Automatically adapt your resume to match any job description. AI detects missing keywords, restructures experience sections, and optimizes formatting — so your CV stands out to ATS screening systems.`)
};

const es_landing_tab_resume_desc = /** @type {(inputs: Landing_Tab_Resume_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Automatically adapt your resume to match any job description. AI detects missing keywords, restructures experience sections, and optimizes formatting — so your CV stands out to ATS screening systems.`)
};

const it_landing_tab_resume_desc = /** @type {(inputs: Landing_Tab_Resume_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Automatically adapt your resume to match any job description. AI detects missing keywords, restructures experience sections, and optimizes formatting — so your CV stands out to ATS screening systems.`)
};

const nl_landing_tab_resume_desc = /** @type {(inputs: Landing_Tab_Resume_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Automatically adapt your resume to match any job description. AI detects missing keywords, restructures experience sections, and optimizes formatting — so your CV stands out to ATS screening systems.`)
};

const pl_landing_tab_resume_desc = /** @type {(inputs: Landing_Tab_Resume_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Automatically adapt your resume to match any job description. AI detects missing keywords, restructures experience sections, and optimizes formatting — so your CV stands out to ATS screening systems.`)
};

const fi_landing_tab_resume_desc = /** @type {(inputs: Landing_Tab_Resume_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Automatically adapt your resume to match any job description. AI detects missing keywords, restructures experience sections, and optimizes formatting — so your CV stands out to ATS screening systems.`)
};

const da_landing_tab_resume_desc = /** @type {(inputs: Landing_Tab_Resume_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Automatically adapt your resume to match any job description. AI detects missing keywords, restructures experience sections, and optimizes formatting — so your CV stands out to ATS screening systems.`)
};

const sv_landing_tab_resume_desc = /** @type {(inputs: Landing_Tab_Resume_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Automatically adapt your resume to match any job description. AI detects missing keywords, restructures experience sections, and optimizes formatting — so your CV stands out to ATS screening systems.`)
};

/**
* | output |
* | --- |
* | "Automatically adapt your resume to match any job description. AI detects missing keywords, restructures experience sections, and optimizes formatting — so yo..." |
*
* @param {Landing_Tab_Resume_DescInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const landing_tab_resume_desc = /** @type {((inputs?: Landing_Tab_Resume_DescInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Tab_Resume_DescInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_landing_tab_resume_desc(inputs)
	if (locale === "fr") return fr_landing_tab_resume_desc(inputs)
	if (locale === "es") return es_landing_tab_resume_desc(inputs)
	if (locale === "it") return it_landing_tab_resume_desc(inputs)
	if (locale === "nl") return nl_landing_tab_resume_desc(inputs)
	if (locale === "pl") return pl_landing_tab_resume_desc(inputs)
	if (locale === "fi") return fi_landing_tab_resume_desc(inputs)
	if (locale === "da") return da_landing_tab_resume_desc(inputs)
	if (locale === "sv") return sv_landing_tab_resume_desc(inputs)
	return en_landing_tab_resume_desc(inputs)
});